<template>
<div class="category-factor-chart-group">
  <div v-if="showHeader" style="line-height:1.8em;margin-bottom:20px;padding:0 10px;background:linear-gradient(to right, #fbc15a 0%, #fff 100%);color:#ffffff;font-weight:600;">
    <span>{{dataConfig.name}}</span>
  </div>

  <Component
    v-for="data in groups"
    :key="data.id"
    :is="`${data.rootFactorId}Chart`"
    :data-config="data"
    :unit-prop="unitProp"
    :factor-group-map="factorGroupMap"
    :chart-type="chartType"
    :stack-type="stackType"
    :download-name="dataConfig.name"
    :chart-min-height="chartMinHeight"
    :current-level="currentLevel"
    :is-show-total="isShowTotal"
    chart-height="auto"
  />
  <!-- :default-show="defaultShow" -->
</div>
</template>

<script>
import DefaultChart from './DefaultChart'
import VOCChart from './VOCChart'
import WeatherChart from './WeatherChart'

export default {
  name: 'CategoryFactorChartGroup',
  components: {DefaultChart, VOCChart, WeatherChart},
  props: {
    factorGroupMap: {
      required: true,
      type: Object
    },
    dataConfig: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    chartMinHeight: {
      type: String,
      default: '400px'
    },
    notCompleteData: {
      type: Boolean,
      default: false
    },
    currentLevel: {
      type: Boolean
    },
    isShowTotal: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    groups: Object.freeze([]),
    chartType: 'line',
    stackType: 0
  }),
  methods: {
    formatDataConfig (dataConfig) {
      let {factorGroupMap} = this
      let {dimensions, dataTimes, seriesMap} = dataConfig
      let dataTimesLen = dataTimes.length - 1
      let groups = Object.values(dimensions.reduce((map, dimension) => {
        let {id, rootFactorId, parentId} = dimension
        let isVOC = rootFactorId === 'VOC'

        if (isVOC) {
          parentId = 'm30000'
        }

        let groups = map[parentId]

        if (!groups) {
          let factorGroup = factorGroupMap[parentId]
          let newRootFactorId = 'Default'

          if (isVOC) {
            newRootFactorId = 'VOC'
          } else if (/^101(0|1|2|3|4)$/.test(id)) {
            newRootFactorId = 'Weather'
          }

          groups = map[parentId] = {
            id: parentId,
            name: factorGroup.name,
            dimensions: [],
            rootFactorId: newRootFactorId,
            seriesMap: {}
          }
        }

        groups.dimensions.push(dimension)
        groups.seriesMap[id] = seriesMap[id]

        return map
      }, {}))

      let {notCompleteData} = this

      groups.forEach(group => {
        if (notCompleteData) {
          let {dimensions, seriesMap} = group
          let lastTSList = dimensions.reduce((list, dimension) => {
            let seriesDataList = Object.values(seriesMap[dimension.id])
            let seriesDataListLen = seriesDataList.length

            if (seriesDataListLen > 0) {
              list.push(seriesDataList[seriesDataListLen - 1].ts)
            }

            return list
          }, [])

          let maxTS = Math.max(...lastTSList)
          let tmpLen = dataTimesLen

          if (tmpLen > -1) {
            while (tmpLen > -1 && maxTS !== dataTimes[tmpLen][0]) {
              tmpLen--
            }

            group.dataTimes = dataTimes.slice(0, tmpLen + 1)
          } else {
            group.dataTimes = []
          }
        } else {
          group.dataTimes = dataTimes
        }
      })

      this.groups = Object.freeze(groups)
    }
  },
  watch: {
    dataConfig: {
      immediate: true,
      handler (dataConfig) {
        if (dataConfig) {
          this.formatDataConfig(dataConfig)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.category-factor-chart-group {

}
</style>



// WEBPACK FOOTER //
// src/components/Data/ChartWrapper/CategoryFactorChartGroup.vue